import React, { useState } from 'react'
import bootstrapScopedStyles from '../../styles/bootstrapScoped.min.module.css'
import formStyles from './../../branding/formStyles'
import customFormStyles from '../../styles/formStyles.module.css'

const OnfsSelect = ({
  name,
  label,
  type,
  placeholder = `Select ${label}`,
  options,
  required = false,
  error,
  handleChange,
  wasSubmitted,
  defaultValue = '',
  ...rest
}) => {
  const isStateSelect = type && type.toLowerCase() === 'states'
  const isRequired = required
  const [selectValue, setSelectValue] = useState(defaultValue)
  const [selectWasTouched, setSelectWasTouched] = useState(false)

  return (
    <div className={bootstrapScopedStyles['form-group']}>
      <label
        htmlFor={name}
        style={formStyles.label}
        className={`${isRequired ? customFormStyles.required : ''}`}
      >
        {label}
      </label>
      <select
        name={name}
        id={name}
        {...rest}
        onChange={(e) => {
          setSelectValue(e.target.value)
          handleChange(e.target)
        }}
        onBlur={() => setSelectWasTouched(true)}
        className={bootstrapScopedStyles['form-control']}
        value={selectValue}
        aria-describedby={
          error && (wasSubmitted || selectWasTouched) ? name + '-error' : null
        }
        aria-invalid={
          error && (wasSubmitted || selectWasTouched) ? 'true' : 'false'
        }
        aria-required={isRequired}
      >
        <option value=''>{placeholder}</option>
        {isStateSelect &&
          states.map((state) => (
            <option key={`${name}_${state}`} value={state}>
              {state}
            </option>
          ))}
        {!isStateSelect &&
          options.map((option) => (
            <option key={`${name}_${option.name}`} value={option.name}>
              {option.name}
            </option>
          ))}
      </select>
      {error && (wasSubmitted || selectWasTouched) && (
        <div
          role='alert'
          id={name + '-error'}
          className={`${bootstrapScopedStyles.alert} ${bootstrapScopedStyles['alert-danger']}`}
        >
          {error}
        </div>
      )}
    </div>
  )
}

const states = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'Other'
]

export default OnfsSelect
